<template>
  <div class="section-title">
    <span class="bar"></span>
    <div class="title-text">
      <h3>{{ title }}</h3>
      <span v-if="subtitle" class="subtitle">{{ subtitle }}</span>
    </div>
    <router-link v-if="more" :to="more" class="more">更多 &gt;&gt;</router-link>
  </div>
</template>

<script>
export default {
  name: "SectionTitle",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    more: { type: [String, Object], default: "" }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/variables.scss";

.section-title {
  display: flex;
  align-items: center;
  border-bottom: 2px solid $color-border;
  padding-bottom: 12px;
  margin-bottom: 18px;

  .bar {
    width: 4px;
    height: 22px;
    background: $color-accent;
    margin-right: 12px;
    flex-shrink: 0;
  }

  .title-text {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: baseline;
    gap: 12px;

    h3 {
      margin: 0;
      font-size: $font-size-title;
      font-weight: 600;
      color: $color-text;
      letter-spacing: 1px;
    }

    .subtitle {
      font-size: 12px;
      color: $color-text-3;
      letter-spacing: 2px;
      text-transform: uppercase;
    }
  }

  .more {
    font-size: 13px;
    color: $color-accent;
    letter-spacing: 1px;
    flex-shrink: 0;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.7;
      text-decoration: underline;
    }
  }
}
</style>
